import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DialogOptions } from 'src/app/interfaces/dialog-data.interface';
import { OnGetData } from 'src/app/services/dialog.service';
import { StateService } from 'src/app/services/state.service';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { LottieComponent } from 'ngx-lottie';

@Component({
    selector: 'app-gallery-limit-reached-dialog',
    templateUrl: './gallery-limit-reached-dialog.component.html',
    styleUrls: ['./gallery-limit-reached-dialog.component.scss'],
    standalone: true,
    imports: [LottieComponent, ButtonDirective],
})
export class GalleryLimitReachedDialogComponent implements OnGetData {
  dialogName = 'gallery-limit-reached';
  close: Function;

  constructor(public state: StateService, private router: Router) {}

  dialogOptions(): DialogOptions {
    return { size: 480, spacingX: 60, spacingY: 40 };
  }

  onGetData(data: any, close: Function) {
    this.close = close;
  }

  continue() {
    this.close();
    this.router.navigate(['a', 'pricing']);
  }
}
